import { Card } from "@mui/material";
import useLogin from "./dialogs/Login";
import MainTabs from "./components/MainTabs"
import Content from "./pages/Content";
import Filters from "./components/Filters"
import CashSummary from "./components/CashSummary";
import Performance from "./components/Performance";
import { usePath } from "./libs/path/PathProvider";
import { ActionFilterProvider } from "./portlibs/ActionFilterProvider";
import { DateRangeFilterProvider } from "./portlibs/DateRangeFilterProvider";

export default function App() {
  const {account, ready} = useLogin()
  const {path} = usePath()
  if (!ready || !account.authenticated) return <Card id="loader">Loading...</Card>    

  let card:React.ReactElement|null = null
  const isHome = path=="/" || path=="/home"
  if (isHome) card = <Performance/>
  else if (path=="/summary" || path=="/fixed" || path=="/holding") card = <CashSummary/>
  return <ActionFilterProvider><DateRangeFilterProvider>
        <MainTabs/>
        <div className="toolbar">
          {card}
          <Filters/>
        </div>
        <div className="body flex1">
          <Content/>
        </div>
  </DateRangeFilterProvider></ActionFilterProvider>
}
